import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { TransferTableComponent } from "./transfer-table/transfer-table.component";
import { TransferComponent } from "./transfer.component";

@NgModule({
  declarations: [TransferComponent, TransferTableComponent],
  imports: [CoreModule],
  exports: [TransferComponent, TransferTableComponent],
})
export class TransferModule {}
